import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import salesChats from 'views/sales/Chats/store'
import liveSupport from 'views/sales/LiveSupport/store'

const rootReducer = (asyncReducers = {}) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        salesChats,
        liveSupport,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
